import React from "react";
import "./Terms_And_Condition.css";
import Common_title from "../common/common-title/Common_title";

function Terms_And_Condition() {
  return (
    <>
      <section className="Terms_And_Condition section_style bg_img_holder">
        <div className="container">
          <Common_title headingText="Terms & " spanText="Conditions" />

          <div className="policy_holder section_holder">
            {/* ABOUT US */}
            <div className="text_holder">
              <h3>1. About Us</h3>
              <p>
                RentEasy is a rent and property management platform that enables
                property owners and tenants to manage properties, rooms, rent
                collection, electricity recharge, invoices, payments, and
                related services digitally through mobile and web applications.
              </p>

              <p>
                <b>Registered Office Address:</b>
              </p>
              <p>
                113, Gavthan Parisar, Kelgaon, PO: Alandi Devachi, Pune,
                Maharashtra – 411021, India
              </p>

              <p>
                <b>Authorized Representative:</b> Mr. Aashish Ganpat Mungase
              </p>
            </div>

            {/* ACCEPTANCE */}
            <div className="text_holder">
              <h3>2. Acceptance of Terms</h3>
              <p>
                By accessing or using RentEasy website or mobile application,
                you agree to be legally bound by these Terms & Conditions.
              </p>
              <p>If you do not agree, please do not use the platform.</p>
            </div>

            {/* SERVICES */}
            <div className="text_holder">
              <h3>3. Services Offered</h3>
              <ul>
                <li>Property & tenant management</li>
                <li>Room allocation</li>
                <li>Rent invoicing & reminders</li>
                <li>Online rent collection</li>
                <li>Electricity recharge tracking</li>
                <li>Payment history & reports</li>
                <li>Subscription-based owner plans</li>
                <li>Document upload & storage</li>
                <li>KYC verification</li>
                <li>Notifications & alerts</li>
              </ul>
            </div>

            {/* USER ACCOUNT */}
            <div className="text_holder">
              <h3>4. User Accounts</h3>

              <p>Users must:</p>
              <ul>
                <li>Register with valid mobile/email</li>
                <li>Verify via OTP/password</li>
                <li>Provide correct personal information</li>
                <li>Maintain account confidentiality</li>
              </ul>

              <p>
                RentEasy may suspend or terminate accounts providing false
                information.
              </p>
            </div>

            {/* PAYMENTS */}
            <div className="text_holder">
              <h3>5. Payments</h3>
              <ul>
                <li>
                  Rent can be paid via UPI, cards, net banking, or wallets
                </li>
                <li>Digital receipts are auto-generated</li>
                <li>Late penalties may apply as set by the property owner</li>
                <li>
                  RentEasy is not responsible for payment gateway or bank delays
                </li>
              </ul>
            </div>

            {/* SUBSCRIPTION */}
            <div className="text_holder">
              <h3>6. Subscription Plans</h3>
              <p>Property owners may subscribe to paid plans.</p>
              <p>
                Subscription fees are non-refundable unless stated otherwise.
              </p>
            </div>

            {/* RESPONSIBILITIES */}
            <div className="text_holder">
              <h3>7. User Responsibilities</h3>

              <p>
                <b>Owners must:</b>
              </p>
              <ul>
                <li>Provide correct property details</li>
                <li>Follow applicable laws</li>
                <li>Maintain lawful tenant agreements</li>
              </ul>

              <p>
                <b>Tenants must:</b>
              </p>
              <ul>
                <li>Pay rent on time</li>
                <li>Submit valid identity documents</li>
                <li>Follow property rules</li>
              </ul>
            </div>

            {/* KYC */}
            <div className="text_holder">
              <h3>8. KYC & Legal Compliance</h3>

              <p>
                To prevent fraud and comply with Indian regulations, users may
                be required to submit:
              </p>

              <ul>
                <li>Aadhaar / Govt ID</li>
                <li>Address proof</li>
                <li>Photograph</li>
                <li>Rent agreement copy</li>
              </ul>

              <p>Failure to complete KYC may lead to service suspension.</p>
            </div>

            {/* CONFIDENTIALITY */}
            <div className="text_holder">
              <h3>9. Confidentiality</h3>
              <p>
                All business, financial, and user information shall remain
                confidential and shall not be disclosed except as required by
                law.
              </p>
            </div>

            {/* IP */}
            <div className="text_holder">
              <h3>10. Intellectual Property</h3>
              <p>
                All software, design, technology, source code, and platform
                features belong exclusively to RentEasy. Unauthorized copying or
                misuse is prohibited.
              </p>
            </div>

            {/* LIABILITY */}
            <div className="text_holder">
              <h3>11. Limitation of Liability</h3>

              <p>
                RentEasy acts only as a technology facilitator and is not liable
                for:
              </p>

              <ul>
                <li>Owner–tenant disputes</li>
                <li>Legal property issues</li>
                <li>Payment gateway failures</li>
                <li>Indirect or incidental damages</li>
              </ul>
            </div>

            {/* TERMINATION */}
            <div className="text_holder">
              <h3>12. Termination</h3>

              <p>Accounts may be terminated for:</p>

              <ul>
                <li>Fraudulent activity</li>
                <li>Misuse of platform</li>
                <li>Non-payment</li>
                <li>Violation of terms</li>
              </ul>
            </div>

            {/* LAW */}
            <div className="text_holder">
              <h3>13. Governing Law & Jurisdiction</h3>
              <p>These terms are governed by Indian laws.</p>
              <p>
                All disputes are subject to the courts of Pune, Maharashtra.
              </p>
            </div>

            {/* CONTACT */}
            <div className="text_holder">
              <h3>14. Contact</h3>
              <p>Email: admin@renteasyapp.in</p>
              <p>Phone: +91-9922054381</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Terms_And_Condition;
